import React from 'react';
import PropTypes from 'prop-types';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';

const ReportUserProgress = React.createClass({


    getDefaultProps: function() {
        return {
            display: {
                fixedHeader: true,
                fixedFooter: true,
                stripedRows: false,
                showRowHover: false,
                showCheckboxes: false,
                selectable: false,
                multiSelectable: false,
                enableSelectAll: false,
                deselectOnClickaway: false,
            },
            data: []
        };
    },
    
    render: function() {

        const style = {
            tdNumber: {
                width: '15%',
                textAlign: 'right'
            }
        };

        let data = this.props.data.map(function(row) {
            row.enrolments = Number(row.enrolments);
            row.completed = Number(row.completed);
            row.waiting = Number(row.waiting);
            row.organisationList = this.getList(row.organisations);
            return row;
        }, this);
        
        let tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        let tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        let tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };
        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }
        
        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>Name</TableHeaderColumn>
                        <TableHeaderColumn>Organisation</TableHeaderColumn>
                        <TableHeaderColumn className="tbl-td-number">Waiting</TableHeaderColumn>
                        <TableHeaderColumn className="tbl-td-number">Enrolments</TableHeaderColumn>
                        <TableHeaderColumn className="tbl-td-number">Completed</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map(function (row, index) {
                        return (
                            <TableRow key={index} selected={row.selected} style={{color: !row.archived ? statusColours.default : statusColours.waiting}}>
                                <TableRowColumn>
                                    <Link to={`/dashboard/user/${row.userId}`}>
                                        {!row.archived
                                            ? row.fullName
                                            : <span style={{color: statusColours.waiting}} title="Archived user">{row.fullName}</span>
                                        }
                                    </Link>
                                </TableRowColumn>
                                <TableRowColumn title={row.organisations.replace(/\|/g, "\n")}>{row.organisationList}</TableRowColumn>
                                <TableRowColumn className="tbl-td-number">{row.waiting || 0}</TableRowColumn>
                                <TableRowColumn className="tbl-td-number">{row.enrolments}</TableRowColumn>
                                <TableRowColumn className="tbl-td-number">{row.completed || 0}</TableRowColumn>
                            </TableRow>
                        );
                    })}
                </TableBody>

            </Table>
        );
    },
    
    getList: function (line, separator) {
        let list = '';
        let spanProps = {
            style: {
                marginRight: '1em'
            },
            className: 'inline-list'
        };
        if (!!line) {
            list = line.split(separator || '|')
                .map(function (e, i) {
                    return <span key={i} {...spanProps} >{e}</span>;
                });
        }
        return list;
    }

});

ReportUserProgress.propTypes = {
    display: PropTypes.object,
    onRowSelect: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
};

export default ReportUserProgress;